import React from "react"
import CarouselSlider from "../../slider/Slider"
import "./cardsSliders.scss"
import { StaticImage } from "gatsby-plugin-image"
import { useMediaQuery } from "react-responsive"
import { Link as GatsbyLink } from "gatsby"
import ItemCard from "../ItemCard/ItemCard"

const CardsSliders = (props) => {
  const { isCertificate, courses } = props

  const isTablet = useMediaQuery({
    query: "(max-width: 768px)",
  })
  const isMobile = useMediaQuery({
    query: "(max-width: 565px)",
  })

  // Helper to filter courses by category key (case-insensitive)
  const filterByCategory = (key) =>
    courses.filter((course) =>
      (course.category || []).some(
        (tag) =>
          typeof tag === "string" &&
          tag.toLowerCase() === key.toLowerCase()
      )
    )

  const ifcCourses = filterByCategory("ifc")
  const autodeskCourses = filterByCategory("autodesk")
  const bentleyCourses = filterByCategory("bentley")
  const bimCourses = filterByCategory("bim")
  const skillsFutureCourses = filterByCategory("skillsFuture")
  const shortCourses = filterByCategory("short-courses")

  const slidesToShow = isMobile ? 1 : isTablet ? 2 : 3
  const slidesToScroll = slidesToShow

  return (
    <div className="courses-courseInfoContainer">
      {/* IFC & CORENET X */}
      {ifcCourses.length > 0 && (
        <div className="courseCover">
          <div className="courseHead">
            <h2 className="title">IFC &amp; CORENET X Courses</h2>
            <p className="subTitle">
              Learn IFC and CORENET X workflows for openBIM
              collaboration and regulatory submissions.
            </p>
          </div>
          <div className="courseSliderCover">
            <CarouselSlider
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              showSlideDots={false}
            >
              {ifcCourses.map((item, i) => (
                <ItemCard
                  key={i}
                  slug={item.slug}
                  coverPhoto={item.coverPhoto}
                  title={item.title}
                  category={item.category}
                  courseReference={item.courseReference}
                  netFee={item.product?.netFee}
                  duration={item.duration}
                  trainingMode={item.trainingMode}
                  courseRuns={item.courseRuns}
                />
              ))}
            </CarouselSlider>
          </div>
          <GatsbyLink
            className="exploreLink"
            to="/courses-ifc"
          >
            Explore IFC &amp; CORENET X courses
            <span className="btnArrow">
              <StaticImage
                src="../../../assets/images/arrow.png"
                alt=""
              />
            </span>
          </GatsbyLink>
        </div>
      )}

      {/* Autodesk */}
      {autodeskCourses.length > 0 && (
        <div className="courseCover">
          <div className="courseHead">
            <h2 className="title">Autodesk Courses</h2>
            <p className="subTitle">
              We are an Authorized Training Partner for Autodesk
              and an Authorized Pearson Vue Test Center.
            </p>
          </div>
          <div className="courseSliderCover">
            <CarouselSlider
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              showSlideDots={false}
            >
              {autodeskCourses.map((item, i) => (
                <ItemCard
                  key={i}
                  slug={item.slug}
                  coverPhoto={item.coverPhoto}
                  title={item.title}
                  category={item.category}
                  courseReference={item.courseReference}
                  netFee={item.product?.netFee}
                  duration={item.duration}
                  trainingMode={item.trainingMode}
                  courseRuns={item.courseRuns}
                />
              ))}
            </CarouselSlider>
          </div>

          <GatsbyLink
            className="exploreLink"
            to={isCertificate ? "/#" : "/courses-autodesk"}
          >
            {isCertificate
              ? "Explore AWS Certifications"
              : "Explore Autodesk courses"}
            <span className="btnArrow">
              <StaticImage
                src="../../../assets/images/arrow.png"
                alt=""
              />
            </span>
          </GatsbyLink>
        </div>
      )}

      {/* Bentley */}
      {bentleyCourses.length > 0 && (
        <div
          className={
            isCertificate
              ? "courseCover certificateCourseCover"
              : "courseCover"
          }
        >
          <div className="courseHead">
            <h2 className="title">Bentley Courses</h2>
            <p className="subTitle">
              We are a Bentley Institute Product Training Partner
              in Singapore. Our trainers are Bentley Qualified
              Trainers certified by Bentley Systems International
              Ltd.
            </p>
          </div>
          <div className="courseSliderCover">
            <CarouselSlider
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              showSlideDots={false}
            >
              {bentleyCourses.map((item, i) => (
                <ItemCard
                  key={i}
                  slug={item.slug}
                  coverPhoto={item.coverPhoto}
                  title={item.title}
                  category={item.category}
                  courseReference={item.courseReference}
                  netFee={item.product?.netFee || item.product?.price}
                  duration={item.duration}
                  trainingMode={item.trainingMode || "Classroom"}
                  courseRuns={item.courseRuns}
                />
              ))}
            </CarouselSlider>
          </div>
          <GatsbyLink
            className="exploreLink"
            to={isCertificate ? "/#" : "/courses-bentley"}
          >
            {isCertificate
              ? "Explore Autodesk Certifications"
              : "Explore Bentley courses"}
            <span className="btnArrow">
              <StaticImage
                src="../../../assets/images/arrow.png"
                alt=""
              />
            </span>
          </GatsbyLink>
        </div>
      )}

      {/* BIM */}
      {bimCourses.length > 0 && (
        <div className="courseCover">
          <div className="courseHead">
            <h2 className="title">BIM Courses</h2>
            <p className="subTitle">
              Build strong fundamentals in Building Information
              Modelling (BIM) for design, coordination, and
              collaboration.
            </p>
          </div>
          <div className="courseSliderCover">
            <CarouselSlider
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              showSlideDots={false}
            >
              {bimCourses.map((item, i) => (
                <ItemCard
                  key={i}
                  slug={item.slug}
                  coverPhoto={item.coverPhoto}
                  title={item.title}
                  category={item.category}
                  courseReference={item.courseReference}
                  netFee={item.product?.netFee}
                  duration={item.duration}
                  trainingMode={item.trainingMode}
                  courseRuns={item.courseRuns}
                />
              ))}
            </CarouselSlider>
          </div>
          <GatsbyLink
            className="exploreLink"
            to="/courses-bim"
          >
            Explore BIM courses
            <span className="btnArrow">
              <StaticImage
                src="../../../assets/images/arrow.png"
                alt=""
              />
            </span>
          </GatsbyLink>
        </div>
      )}

      {/* SkillsFuture */}
      {skillsFutureCourses.length > 0 && (
        <div className="courseCover">
          <div className="courseHead">
            <h2 className="title">SkillsFuture Courses</h2>
            <p className="subTitle">
              Eligible courses supported under SkillsFuture to
              help you upskill and stay competitive.
            </p>
          </div>
          <div className="courseSliderCover">
            <CarouselSlider
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              showSlideDots={false}
            >
              {skillsFutureCourses.map((item, i) => (
                <ItemCard
                  key={i}
                  slug={item.slug}
                  coverPhoto={item.coverPhoto}
                  title={item.title}
                  category={item.category}
                  courseReference={item.courseReference}
                  netFee={item.product?.netFee}
                  duration={item.duration}
                  trainingMode={item.trainingMode}
                  courseRuns={item.courseRuns}
                />
              ))}
            </CarouselSlider>
          </div>
          <GatsbyLink
            className="exploreLink"
            to="/courses-skillsfuture"
          >
            Explore SkillsFuture courses
            <span className="btnArrow">
              <StaticImage
                src="../../../assets/images/arrow.png"
                alt=""
              />
            </span>
          </GatsbyLink>
        </div>
      )}

      {/* 1-Day Short Courses */}
      {shortCourses.length > 0 && (
        <div className="courseCover">
          <div className="courseHead">
            <h2 className="title">1-Day Short Courses</h2>
            <p className="subTitle">
              Compact, focused courses designed to upgrade your
              skills in just one day.
            </p>
          </div>
          <div className="courseSliderCover">
            <CarouselSlider
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              showSlideDots={false}
            >
              {shortCourses.map((item, i) => (
                <ItemCard
                  key={i}
                  slug={item.slug}
                  coverPhoto={item.coverPhoto}
                  title={item.title}
                  category={item.category}
                  courseReference={item.courseReference}
                  netFee={item.product?.netFee}
                  duration={item.duration}
                  trainingMode={item.trainingMode}
                  courseRuns={item.courseRuns}
                />
              ))}
            </CarouselSlider>
          </div>
          <GatsbyLink
            className="exploreLink"
            to="/short-courses"
          >
            Explore 1-day short courses
            <span className="btnArrow">
              <StaticImage
                src="../../../assets/images/arrow.png"
                alt=""
              />
            </span>
          </GatsbyLink>
        </div>
      )}
    </div>
  )
}

export default CardsSliders